module.exports = __webpack_public_path__ + "static/media/weekly.50283deb.svg";